module.exports = __webpack_public_path__ + "img/diamond_co.37b426a8.png";